
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M10 5v14a1 1 0 01-1 1H3a1 1 0 01-1-1V5a1 1 0 011-1h6a1 1 0 011 1zm5 8h-2a1 1 0 00-1 1v5a1 1 0 001 1h2a1 1 0 001-1v-5a1 1 0 00-1-1zm6 0h-2a1 1 0 00-1 1v5a1 1 0 001 1h2a1 1 0 001-1v-5a1 1 0 00-1-1zm0-9h-8a1 1 0 00-1 1v5a1 1 0 001 1h8a1 1 0 001-1V5a1 1 0 00-1-1z"}})])
          )
        }
      }
    